<template>
<div class="drawerWrap InstallRecord">
  <div class="drawerBody">
    <!-- :rules="formRules" -->
    <border-table :tableData="dataList" :pageSizes="[10, 20, 50]" :pages="pagination"  :loading="tableLoading" :current-page="pagination.page" @currentChange="handleRoleCurrentChange" @sizeChange="handleRoleSizeChange">
      <el-table-column prop="id" label="操作类型" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="!scope.row.type" style="color:#00b050">安装</span>
          <span style="color:#ff0000" v-else>拆卸</span>
        </template>
      </el-table-column>
      <el-table-column prop="isTenantInstall" label="是否租户操作">
        <template slot-scope="scope">
          <span v-if="scope.row.isTenantInstall" style="color:#00b050">是</span>
          <span style="color:#ff0000" v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="nickName" label="操作者">
        <template slot-scope="scope">
          <span v-if="scope.row.isTenantInstall">{{scope.row.tnickName}}</span>
          <span v-else>{{scope.row.unickName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="installLocation" label="安装位置" show-overflow-tooltip></el-table-column>  
      <el-table-column prop="createTime" label="操作时间" show-overflow-tooltip></el-table-column>     
      <el-table-column prop="useTime" label="使用时长（s）" show-overflow-tooltip></el-table-column>
    </border-table>
  </div>
</div>
</template>

<script>
import AddressSelect from '@/components/common/AddressSelect'
import BorderTable from "@/components/common/BorderTable";
export default {
  components: {
    AddressSelect,
    BorderTable
  },
  props: {
    installRecordPar: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dataList: [],
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      tableLoading: false,
    }
  },
  created() {
    this.getDataList()
  },

  methods: {
    async getDataList() {
      let par = {
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        sort: "createTime",
        order: 'desc',
        deviceId:this.installRecordPar.id
      }
      const {
        data,
        msg,
        code
      } = await this.request.post('/front/device/install/record/query', par)
      if (code !== 200) {
        if(code==500){
          return this.$message.error(msg)
        }
        return
      }
      this.dataList = data.data
      this.pagination.total = data.totalCount;
      console.log(`data`, data)
    },
    // cancelHandle() { //取消
    //   this.$emit("cancel", false);
    // },
    // confirmHandle() {
      // let par = {
      //   ...this.device,
      //   installUserId: this.storage.getSession("userId"),
      //   id: this.install.id,
      //   installGps: this.device.coordinate
      // }
      // delete par.msg
      // delete par.coordinate
      // par
    /*   this.$emit('installConfirm')
    }, */
      //表格当前页变化时
    handleRoleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getDataList();
    },
    
    //表格展示条数变化时
    handleRoleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage=1
      this.getDataList();
    },

  }
};
</script>

<style lang="scss">
.InstallRecord{
  &.drawerWrap{
    .el-select{
      .el-input{
        .el-select__caret{
          line-height: 28px !important;
        }
      }
    }
  }
}
.drawerWrap {
  .el-transfer {
    .el-transfer-panel {
      text-align: left;
      width: 250px;
    }

    .el-transfer__buttons {
      width: 65px;
      text-align: center;

      .el-button {
        margin: 5px 0;
        width: 56px;
      }
    }
  }

  .el-switch {
    width: 100%;
  }

  .el-image {
    margin-right: 20px;
  }

  .el-form {
    margin-top: 20px;

    .el-form-item__label {
      line-height: 50px;
    }

    .el-form-item__content {
      line-height: 50px;
    }

    .el-select {
      width: 100%;
    }

    .el-textarea {
      width: 270px;

      .el-textarea__inner {
        height: 100px !important;
        line-height: 20px;
        color: #6e6e6e;
        font-size: 14px;
      }
    }

    .el-input {
      width: 270px;

      .el-input__inner {
        height: 40px;
        line-height: 40px;
      }
    }
  }

  .drawerBody .el-form-item__label,
  .sp {
    color: #6e6e6e;
  }

}
</style>
